import mqtt from "mqtt";

const DEFAULT_HOST = process.env.REACT_APP_MQTT_HOST || "eeb1e83a06da4b44b7a340bc19cd1e75.s1.eu.hivemq.cloud";
const DEFAULT_PORT = process.env.REACT_APP_MQTT_PORT || "8884";
const DEFAULT_USER = process.env.REACT_APP_MQTT_USER || "cput_energy";
const DEFAULT_PASS = process.env.REACT_APP_MQTT_PASS || "Hnk@2026";

export const TOPICS = {
  STATE:      "campus/energy/state",
  PZEM:       "campus/energy/pzem",
  CMD:        "campus/energy/cmd",
  PZEM_CMD:   "campus/energy/pzem_cmd",
  CAM_CMD:    "campus/camera/cmd",
  CAM_IMG:    "campus/camera/img",
  CAM_STATE:  "campus/camera/state",
  CAM_MOTION: "campus/camera/motion",
};

let client = null;

function createClient(host, port, user, pass) {
  const url = `wss://${host}:${port}/mqtt`;
  console.log("[MQTT] createClient → url:", url, "| user:", user);
  const c = mqtt.connect(url, {
    username: user,
    password: pass,
    clientId: `cem_web_${Math.random().toString(16).slice(2, 10)}`,
    protocolVersion: 4,
    keepalive: 60,
    reconnectPeriod: 5000,
    connectTimeout: 15000,
    clean: true,
  });
  c.on("connect",      ()     => console.log("[MQTT] ✅ connected"));
  c.on("reconnect",    ()     => console.log("[MQTT] 🔄 reconnecting…"));
  c.on("offline",      ()     => console.log("[MQTT] 📴 went offline"));
  c.on("disconnect",   (pkt)  => console.log("[MQTT] 🔌 disconnected", pkt));
  c.on("close",        ()     => console.log("[MQTT] 🔒 connection closed"));
  c.on("error",        (err)  => console.error("[MQTT] ❌ error:", err?.message || err));
  c.on("message",      (t, p) => console.log("[MQTT] 📨 message on", t, "| payload len:", p.length));
  c.on("packetreceive",(pkt)  => console.log("[MQTT] ← packet:", pkt?.cmd));
  c.on("packetsend",   (pkt)  => console.log("[MQTT] → packet:", pkt?.cmd));
  return c;
}

export function getMqttClient() {
  if (client) return client;
  client = createClient(DEFAULT_HOST, DEFAULT_PORT, DEFAULT_USER, DEFAULT_PASS);
  return client;
}

export function reconnectMqtt(host, user, pass) {
  if (client) { client.end(true); client = null; }
  client = createClient(host || DEFAULT_HOST, DEFAULT_PORT, user || DEFAULT_USER, pass || DEFAULT_PASS);
  return client;
}

export function publishCmd(device, action) {
  const c = getMqttClient();
  if (!c.connected) throw new Error("MQTT not connected");
  c.publish(TOPICS.CMD, JSON.stringify({ cmd: device, val: action }), { qos: 0 });
}

export function publishCamCmd(cmd) {
  const c = getMqttClient();
  if (!c.connected) throw new Error("MQTT not connected");
  c.publish(TOPICS.CAM_CMD, String(cmd), { qos: 0 });
}

export function publishPzemCmd(cmd, val) {
  const c = getMqttClient();
  if (!c.connected) throw new Error("MQTT not connected");
  c.publish(TOPICS.PZEM_CMD, JSON.stringify({ cmd, val }), { qos: 1 });
}

export function disconnectMqtt() {
  if (client) { client.end(true); client = null; }
}
